import React, { Fragment, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../contextStore/AuthContext';
import { ToastContext } from '../../contextStore/ToastContext';
import OverlaySpinner from '../Loading/OverlaySpinner';
import AdForm from './AdForm';
import './Create.css';
import { handleSaveDraft, handleSubmit } from './createHandlers';
import { useCreateForm } from './useCreateForm';

const Create = () => {
  const { t, i18n } = useTranslation();
  const { user } = useContext(AuthContext);
  const { addToast } = useContext(ToastContext);
  const history = useHistory();
  const {
    values,
    loading,
    draftLoading,
    setDraftLoading,
    errors,
    setErrors,
    setLoading,
    onChange,
  } = useCreateForm();

  const onSubmit = () =>
    handleSubmit({
      values,
      user,
      addToast,
      history,
      setLoading,
      setErrors,
      t,
      lang: i18n.language,
    });

  const onSaveDraft = () =>
    handleSaveDraft({
      values,
      user,
      addToast,
      history,
      setLoading: setDraftLoading,
      setErrors,
      t,
      lang: i18n.language,
    });

  return (
    <Fragment>
      {(loading || draftLoading) && <OverlaySpinner />}
      <div className="createPageWrap">
        <div className="createPageActions">
          <Link to="/" className="createCancelLink">
            ← {t('common.cancel')}
          </Link>
        </div>
        <AdForm
          values={values}
          onChange={onChange}
          errors={errors}
          loading={loading}
          draftLoading={draftLoading}
          onSubmit={onSubmit}
          submitLabel={t('createAd.submit')}
          onSaveDraft={onSaveDraft}
        />
      </div>
    </Fragment>
  );
};

export default Create;
